import { Divider } from "@mui/material";
import { TabbedShowLayout as RATabbedShowLayout, Tab } from "react-admin";

export const TabbedShowLayout = ({ children, ...props }) => (
  <RATabbedShowLayout divider={<Divider flexItem />} {...props}>
    {children}
  </RATabbedShowLayout>
);

TabbedShowLayout.Tab = Tab;
